export default "__VITE_ASSET__BDPHkG4V__"